<div class="stu-login">
	<div class="stu-login-logo">
		<mat-icon class="stu-login-logo-icon" svgIcon="am_with_text"></mat-icon>
	</div>
	<ng-container>
		<form class="stu-login-form" [formGroup]="passwordFormGroup" (ngSubmit)="onForgotPasswordSubmit()" novalidate autocomplete="off">
			<div class="stu-login-problem-box">
				<h1 class="stu-login-title" translate>forgot.password</h1>
			</div>
			<mat-form-field appearance="standard" [hideRequiredMarker]="true" class="stu-login-field">
				<mat-label translate>login-legacy.email-address</mat-label>
				<input matInput type="text" name="userEmail" required autocomplete="userEmail" autocapitalize="none" spellcheck="false" formControlName="userEmail">
				<button type="button" *ngIf="passwordFormGroup.get('userEmail')!.value" matSuffix mat-icon-button (click)="passwordFormGroup.get('userEmail')!.reset('')" tabindex="-1" [disabled]="submitting">
					<mat-icon svgIcon="md:close" class="copo-small-close"></mat-icon>
				</button>
				<mat-error translate>email.required</mat-error>
			</mat-form-field>
			<button mat-raised-button color="accent" class="stu-login-field" type="submit" [disabled]="submitting">
				<span *ngIf="!submitting; else submittingMessage" translate>reset.password</span>
				<ng-template #submittingMessage><span translate>login.loading</span></ng-template>
			</button>
		</form>
	</ng-container>
</div>
<div class="stu-login-copyright">
	© ArcelorMittal {{ year }}&ngsp;
	<a (click)="openPrivacyPolicyDialog()" translate>login-legacy.privacy-settings</a>
</div>